<app-common-modal #editOptionValueModal [name]="'editAccessoryValueModal'" [title]=" " [twoButtonsDialogs]="true" [withFooter]="false">

  <h4 class="modal-title" modal-title translate>T_OFFER_DATA_MANAGEMENT_OPTION_VALUE_INFORMATION</h4>
  <div modal-body>
    <div *ngIf="availableOptions">
      <h5 translate>T_OPTION_SELECT</h5>
      <p-dropdown
        class="edit-option-value-dropdown"
        [options]="availableOptions"
        [(ngModel)]="editOptionValueForm.optionNameKey"
        optionLabel="nameTranslated"
        optionValue="name">
      </p-dropdown>
    </div>

    <h5 translate>T_OPTION_REFERENCE</h5>
    <p *ngIf="!editOptionValueForm.bslReference">
      <span translate>T_OPTION_NO_REFERENCE</span>
    </p>
    <p *ngIf="editOptionValueForm.bslReference">
      <span class="break-text">{{editOptionValueForm.bslReference}}</span>
      <button (click)="clickDeleteReferenceButton()" class="action-button se-icon">action_delete</button>
    </p>
    <button (click)="clickAddReferenceButton()" *ngIf="!editOptionValueForm.bslReference" class="btn btn-smart btn-gray" translate>
      <span class="se-icons">action_add_stroke</span>T_OPTION_REFERENCE_ADD_BUTTON
    </button>

    <h5 translate>T_OPTION_NAME</h5>
    <app-spinner *ngIf="isLoading" [sizeClass]="'medium'" class="spinner"></app-spinner>
    <div *ngIf="!isLoading">
      <div class="edit-option-value-name" *ngFor="let item of editOptionValueForm.name | keyvalue; trackBy: trackByFn">
        <span class="edit-option-value-name-label">{{item.key}}:</span>
        <input class="edit-option-value-name-input" type="text" [(ngModel)]="editOptionValueForm.name[item.key]"/>
      </div>

    <h5 translate>T_OPTION_DESCRIPTION</h5>
    <div *ngFor="let item of editOptionValueForm.description | keyvalue; trackBy: trackByFn" class="edit-option-value-description">
      <span class="edit-option-value-description-label ">{{item.key}}:</span>
      <input [(ngModel)]="editOptionValueForm.description[item.key]" class="edit-option-value-description-input" type="text" />
    </div>
    </div>


    <div class="edit-option-value-modal-footer">
      <button (click)="hide()" class="btn btn-default-white-background" translate>T_BUTTON_CANCEL</button>
      <button (click)="clickOnSaveOptionValue(); hide()" [disabled]="!isValidForm()" class="btn btn-default-white-background" translate>T_OFFER_DATA_MANAGEMENT_SAVE_OPTION_BUTTON</button>
    </div>
  </div>


</app-common-modal>

<!--Modal add reference-->
<app-odm-add-modal #addReferenceModal
                                     (onAddReferenceButton)="addReference($event)"
                                     [accessType]="'option'"
                                     [isOption]="true"
                                     [notAllowedReferenceCategories]="notAllowedReferenceCategoriesForOptions"
                                     [selectedRange]="selectedRange"
>
</app-odm-add-modal>
